<template>
  <el-contianer>



  <div>
    <el-container>
      <el-row style="width: 98%;">
        <el-col :span="15" :offset="6">

          <el-container class="SelectBlock">


            <el-col class="FirstBlock" :sapn="3" >
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">根据员工查询</el-dropdown-item>
                  <el-dropdown-item command="b">根据电话查询</el-dropdown-item>
                  <el-dropdown-item command="c">根据公司编号查询</el-dropdown-item>
                  <el-dropdown-item command="d">根据部门编号查询</el-dropdown-item>
                  <el-dropdown-item command="e">权限</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

                <el-input v-if="selectCheck == 'a'" v-model.trim="SForm.Sname" :value="ManagerUser"  placeholder="根据员工查询">
                    <el-button
                      size="mini"
                       style="padding-right:10px"
                       slot="suffix"
                       type="text"
                      @click="dialogManager = true">选择</el-button> </el-input>
                      <el-dialog title="选择资产类别" :visible.sync="dialogManager" width="35%">
                        <el-tree
                          class ="TreeBlock"
                          :data="MangerData"
                          :filter-node-method="filterNode"
                          node-key="id"
                          @node-click="TreeMangerClick"
                          ref="tree"
                          :props="defaultProps"
                          default-expand-all:false
                          :expand-on-click-node="false">
                          <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>
                          </span>
                        </el-tree>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="dialogManager = false">取 消</el-button>
                          <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                        </div>
                      </el-dialog>


                  <el-input v-if="selectCheck == 'b'" v-model.trim="SForm.Sphone" placeholder="根据电话查询"></el-input>


                  <el-select v-if="selectCheck == 'c'" v-model.trim="SForm.SunitId" placeholder="根据公司编号查询">
                      <el-option
                      v-for="i in DUnit"
                      :key="i.unitName"
                      :label="i.unitName"
                      :value="i.unitId">

                      </el-option>
                  </el-select>


                  <el-select @change="departmentIdChange" v-if="selectCheck == 'd'" v-model.trim="SForm.SdepartmentId" placeholder="根据部门编号查询">
                      <el-option
                      v-for="i in DName"
                      :key="i.departmentId"
                      :label="i.departmentName"
                      :value="i.departmentId">
                      </el-option>
                  </el-select>



                  <el-select v-if="selectCheck == 'e'" v-model.trim="SForm.SroleId" placeholder="权限">
                    <el-option label="系统管理员" value="1"></el-option>
                    <el-option label="单位管理员" value="2"></el-option>
                    <el-option label="资产管理员" value="3"></el-option>
                    <el-option label="盘点员" value="4"></el-option>
                    <el-option label="资产使用者" value="5"></el-option>
                    <el-option label="编外人员" value="6"></el-option>
                  </el-select>






              <el-button type="primary" @click="select(1)">查询</el-button>
              <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
            </el-col>

              <el-button type="danger" @click="handleDelete()">删除</el-button>
              <el-button type="primary" @click="dialogVisible = true">添加员工</el-button>
              <el-button type="primary" @click="download()">导出</el-button>



              <el-dialog
                title="员工添加"
                :visible.sync="dialogVisible"
                width="30%">

                <el-button type="primary" @click="dialogFormVisible = true">添加单个员工</el-button>
                <el-upload
                  style="margin-top: 2%;"
                  class="upload-demo"
                  action="https://assert.hyhdit.com/apiYang/user/importExcelBigData"
                  :on-change="handleChange"
                  :on-success="handleSuccess"
				  :on-progress="handleProgress"
                  :headers="token"
                  :file-list="fileList">
                  <el-button  type="danger">点击上传文件批量导入员工信息</el-button>
                </el-upload>




                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
              </el-dialog>
          </el-container>

        </el-col>


          <el-dialog title="添加员工" append-to-body :visible.sync="dialogFormVisible" width="25%" >
            <el-form label-width="80px">
              <el-form-item label="部门">
                <el-select v-model="departmentId" placeholder="部门">
                    <el-option
                    v-for="i in DName"
                    :key="i.departmentName"
                    :label="i.departmentName"
                    :value="i.departmentId">

                    </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="联系方式">
                <el-input v-model.trim="phone" style="width: 350px;" placeholder="联系方式"></el-input>
              </el-form-item>


              <el-form-item label="性别">
                <el-select v-model="sex" placeholder="性别">
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="单位">
                <el-select v-model="unitId" placeholder="单位">
                    <el-option
                    v-for="i in DUnit"
                    :label="i.unitName"
                    :key="i.unitName"
                    :value="i.unitId">
                    </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="用户名">
                <el-input v-model.trim="username" style="width: 50%;" placeholder="用户名"></el-input>
              </el-form-item>
              <el-form-item label="权限">
                <el-select v-model="roles" multiple placeholder="权限">
                  <el-option label="系统管理员" value="1"></el-option>
                  <el-option label="单位管理员" value="2"></el-option>
                  <el-option label="资产管理员" value="3"></el-option>
                  <el-option label="盘点员" value="4"></el-option>
                  <el-option label="资产使用者" value="5"></el-option>
				  <el-option label="编外人员" value="6"></el-option>
                </el-select>
              </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible = false;add()">确 定</el-button>

            </div>
          </el-dialog>





      </el-row>
    </el-container>

  </div>



    <el-table
        :data="tableData"
        border
         @selection-change="handleSelectionChange"
        style="width: 100%;margin-top: 1%;">

        <el-table-column
              type="selection"
              width="55">
            </el-table-column>

        <el-table-column
          prop="username"
          label="用户名称"
          width="180">
        </el-table-column>

        <el-table-column
          prop="unit"
          label="单位名称"
          width="180">
        </el-table-column>

        <el-table-column
          prop="department"
          label="部门名称"
          width="180">
        </el-table-column>

        <el-table-column
          prop="roles"
          label="权限"
          width="180">
		  <template slot-scope="scope">
			  {{scope.row.roles}}
		   </template>
        </el-table-column>

          <el-table-column
            prop="phone"
            label="用户联系方式"
            width="180">
          </el-table-column>

        <el-table-column
          label="创建时间"
          width="180">
          <template slot-scope="scope">
           {{formattedTime(scope.row.createDate)}}</template>

        </el-table-column>


        <el-table-column
          label="修改时间"
          width="180">
          <template slot-scope="scope">
           {{formattedTime(scope.row.updateDate)}}</template>

        </el-table-column>

        <el-table-column label="操作">

              <template slot-scope="scope">

                <el-button
                  size="mini"
                  @click="dialogFormEdit = true;EditData(scope.row)">编辑</el-button>
                  <el-dialog title="修改员工" :visible.sync="dialogFormEdit" width="35%">
                    <el-form>
                  <el-form-item label="部门">
                    <el-select v-model="EdepartmentName" placeholder="部门" :value="EdepartmentId">
                          <el-option
                          v-for="i in DName"
                          :key="i.departmentId"
                          :label="i.departmentName"
                          :value="i.departmentId">
                          </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="联系方式">
                      <el-input v-model.trim="Ephone" style="width: 50%;" placeholder="联系方式"></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                      <el-select v-model="EsexData" placeholder="性别" :value="Esex">
                        <el-option label="男" value="1"></el-option>
                        <el-option label="女" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="单位">
                      <el-select v-model="EunitId" placeholder="单位">
                          <el-option
                          v-for="i in DUnit"
                          :key="i.unitName"
                          :label="i.unitName"
                          :value="i.unitId">
                          </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="用户名">
                      <el-input v-model.trim="Eusername" style="width: 50%;" placeholder="用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="权限">
                      <el-select v-model="Eroles" placeholder="权限" multiple>
                        <el-option label="系统管理员" value="1"></el-option>
                        <el-option label="单位管理员" value="2"></el-option>
                        <el-option label="资产管理员" value="3"></el-option>
                        <el-option label="盘点员" value="4"></el-option>
                        <el-option label="资产使用者" value="5"></el-option>
						            <el-option label="编外人员" value="6"></el-option>
                      </el-select>
                    </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">取 消</el-button>
                      <el-button type="primary" @click="dialogFormEdit = false;handleEdit(scope.$index, scope.row)">确 定</el-button>
                    </div>
                  </el-dialog>

              </template>
            </el-table-column>

      </el-table>
      <div class="block">

		   <el-pagination
		        @size-change="handleSizeChange"
		        @current-change="select"
		        :current-page="currentPage"
		        :page-sizes="[10, 20, 50, 100]"
		        :page-size="pageSize"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="total">
		      </el-pagination>




          <!-- <el-pagination
            @size-change="select"
            @current-change="select"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"

            :total="pageSize">
          </el-pagination> -->
        </div>
  </div>
  </el-contianer>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import qs from "qs"
  export default {
     name: 'User',
     data () {
       return {
         drawer: false,

         multipleSelection: [],
         token:{
           Authorization:Cookies.get("Authorization")
         },
         dialogVisible:false,
         direction: 'rtl',
         currentPage: 1,
         pageSize:20,
		 total:0,
        dialogFormVisible: false,
        dialogFormEdit: false,
        dialogManager:false,
        ManagerUser:'',
        EsexData:'',
        MangerData: [{
          id:'',
          label: '',
          realId:'',
          operator:'',
          children: [{
            id:'',
            label: '',
            realId:'',
            operator:'',
            children: [{
              id:'',
              label: '',
              realId:'',
              operator:'',
            }]
          }]
        }],


        SForm:{
          Sname:'',
          Sphone:'',
          SunitId:'',
          SdepartmentId:'',
          SroleId:'',
        },
        fileList: [{
                 name: '数据一.xlsx',
               }, {
                 name: '数据二.xlsx',
               }],
        selectCheck:'',
        defaultProps: {
                 children: 'children',
                 label: 'label'
               },
        departmentId:'',
        phone:'',
        sex:'',
        unitId:'',
        username:'',
        roles:'',
        EdepartmentId:'',
        EdepartmentName:'',
        Ephone:'',
        Esex:'',
        EunitId:'',
        Eusername:'',
        EuserId:'',
        Eroles:'',
        EroleIds:[],
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        DUnit:[{
          unitName:'',
          unitId:'',
        }],
        tableData: [{
                department: '',
                phone: '',
                roles:'',
                unit:'',
                sex:'',
                username:'',
                createDate:'',
                updateDate:'',
              }
              ]}
       },
     created:function() {
       this.select();
       this.showDepartmentData();
       this.showUnitData();
       this.showMData();
     },
     methods: {
      download() {
        // let data = {
          
        // }
        this.axios({
          method: 'POST',
          url: '/user/exportExcelSmallData',
          data: {
            unitId: Cookies.get("UnitId"),
            username: '',
            phone: '',
            departmentId: '',
            roleId: '',
            currentPage: '',
            pageSize: '',
            del: 1,
          },
          header:{
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
          }
        }).then(res => {
          if(res.data.code === 200) {
            location.href = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      departmentIdChange(val) {
        console.log(val)
      },
      handleSuccess(res){
        if(res.code==200){
        	this.open4(res.message)
			this.showData()
        }else{
        	this.open3(res.message)
        }
      },
      formattedTime(val) {
              const date = new Date(val);
              const year = date.getFullYear();
              const month = ("0" + (date.getMonth() + 1)).slice(-2);
              const day = ("0" + date.getDate()).slice(-2);
              return `${year}-${month}-${day} `;
            },

      EditData(rows) {
          this.EdepartmentName = rows.department
          this.Ephone = rows.phone
          this.Eusername = rows.username
		      this.EunitId= rows.unit  
          this.Eroles = rows.roles
          if(rows.sex == 1){
           this.EsexData = '男'
         }else if(rows.sex == 2){
           this.EsexData = '女'
         }
         this.EuserId = rows.userId;
           },



      open3(val) {
            this.$notify({
              message: val,
              type: 'warning',
              duration: 3000
            });
           },


			handleProgress() {
				this.$notify({
				  title: '上传中......',
				  message: '上传中，请稍等.....',
				  type: 'warning',
				  duration: 3000
				});
			},


      handleSelectionChange(val) {
          this.multipleSelection = val;
            },


       handleChange(file, fileList) {
               this.fileList = fileList.slice(-3);
             },


      resetForm(formName) {
        Object.assign(this.$data.SForm, this.$options.data().SForm)
        this.select()
          },
      filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },
      TreeMangerClick(data){
          if(data.operator == 1){
            this.ManagerUser = data.realId
            this.SForm.Sname = data.label
            this.dialogManager =false
          }else{
            return;
          }


      },





      showDepartmentData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 10,
       }
        this.axios({
            method: 'GET',
            url: '/public/getCanHandleDepartmentList',
            params:params,
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           this.DName = resp.data.data;
          })
      },

      showMData(){
       var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'GET',
            url: '/public/getUnitTree',
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           this.MangerData=resp.data.data;
          })
      },




      showUnitData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 10,
       }
        this.axios({
            method: 'GET',
            url: '/public/getCanWatchUnit',
            params:params,
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           this.DUnit = resp.data.data;

          })
      },

      handleCommand(command) {
             this.selectCheck = command
            },





       showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/user/showUserDetail',
             params:params,
             header:{
              // 'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{

            this.tableData=resp.data.data;
            this.total = resp.data.count;
           })
       },

	   handleSizeChange(val){
		 this.pageSize = val
		 this.select()
	   },


         select(val){
            // if(this.SForm.SdepartmentId == 1000) {
            //   this.SForm.SdepartmentId = 0
            // }
            var authorization = Cookies.get("Authorization");
            var SPhone =  parseInt(this.SForm.Sphone)
            this.currentPage = val
            var paramsData = {
              currentPage: val || 1 || undefined,
              pageSize: this.pageSize,
              username:this.SForm.Sname || undefined,
              phone:SPhone || undefined,
              unitId:this.SForm.SunitId || undefined,
              departmentId:this.SForm.SdepartmentId,
              roleId:this.SForm.SroleId || undefined

            }
             this.axios({
                 method: 'GET',
                 url: '/user/showUserDetail',
                 params:paramsData,
                 header:{
                  'Authorization':authorization,
                 	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                 	}
               }).then((resp)=>{

                  this.tableData=resp.data.data;
                  this.total = resp.data.count;
               })
         },

         add(){
           var authorization = Cookies.get("Authorization");

           var Arry = [];
           this.roles.forEach(str=>{
             Arry.push(parseInt(str))
           })



           this.axios({
               method: 'POST',
               url: '/user/addUser',
               data: {
                 departmentId:this.departmentId,
                 phone:this.phone,
                 sex:parseInt(this.sex),
                 unitId:this.unitId,
                 username:this.username,
                 roles:Arry,
               },  //这里json对象会转换成json格式字符串发送
               paramsSerializer:data =>{
                 return qs.stringify(data,{indices:false})
               },
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                            if(resp.data.code==200){
                              this.open4(resp.data.message)
                              this.select(this.currentPage)
                            }else{
                              this.open3(resp.data.message)
                            }
                          })

         },
         handleEdit(index, row) {
              var authorization = Cookies.get("Authorization");
              var Arry = [];

              this.Eroles.forEach(str=>{
                if(str == "资产管理员"){
                  Arry.push(3)
                }else if(str == "资产使用者"){
                  Arry.push(5)
                }else if(str == "系统管理员"){
                  Arry.push(1)
                }else if(str == "单位管理员"){
                  Arry.push(2)
                }else if(str == "编外人员"){
                  Arry.push(6)
                }else{
                  Arry.push(parseInt(str))
                }
              })


              this.axios({
                  method: 'POST',
                  url: '/user/update',
                  data:{
                    departmentId:parseInt(this.EdepartmentName),
                    phone:this.Ephone,
                    sex:parseInt(this.Esex),
                    unitId:parseInt(row.unitId),
                    username:this.Eusername,
                    userId:parseInt(this.EuserId),
                    roles:Arry,
                    del:1
                  },
                  header:{
                   'Authorization':authorization,
                   'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                }).then((resp)=>{
                            if(resp.data.code==200){
                              this.open4(resp.data.message)
                              this.select(this.currentPage)
                            }else{
                              this.open3(resp.data.message)
                            }
                          })

              },

			  open4(val) {
			  			this.$notify({
			  				title: val,
			  				message: val,
			  				type: 'success',
			  				duration: 3000
			  				});
			  			},



              handleDelete() {

                var authorization = Cookies.get("Authorization");
                var deleteData = []

                for(let i of this.multipleSelection){
                  deleteData.push(i.userId)
                }

                this.axios({
                    method: 'POST',
                    url: '/user/del',
                    params:{
                      ids:deleteData
                    },
                    paramsSerializer:params =>{
                      return qs.stringify(params,{indices:false})
                    },
                    header:{
                     'Authorization':authorization,
                    	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                    	}
                  }).then((resp)=>{
                            if(resp.data.code==200){
                              this.open4('删除成功')
                              this.select(this.currentPage)
                            }else{
                              this.open3(resp.data.message)
                            }

                          })
              }
     }
   }
</script>

<style>
.SelectBlock .el-input{
      width: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Munber/User.vue